import { styled } from '@mui/styles';

export const FilterGropItemWrapper = styled('div')(({ theme }) => ({
  '&:not(:last-child)': {
    marginBottom: theme.spacing(3)
  }
}));
